import { c as _c } from "react/compiler-runtime";
import { useRef } from 'react';
export interface HomeCopilotElementRefs {
  dateRangeCalendarRef: React.RefObject<HTMLButtonElement | null>;
  filterBarRef: React.RefObject<HTMLDivElement | null>;
  scorecardGroupRef: React.RefObject<HTMLDivElement | null>;
  progressOverTimeChartRef: React.RefObject<HTMLDivElement | null>;
  detailedTableRef: React.RefObject<HTMLDivElement | null>;
  recommendationsRef: React.RefObject<HTMLDivElement | null>;
  moreMenuButtonRef: React.RefObject<HTMLButtonElement | null>;
}

/**
 * Creates stable DOM refs for major home-dashboard sections targeted by copilot tools.
 *
 * Ref objects are created once per mount so CopilotContext can register highlight
 * and scroll targets without chasing changing ref identities.
 */
export const useHomeCopilotElementRefs = () => {
  const $ = _c(1);
  const dateRangeCalendarRef = useRef(null);
  const filterBarRef = useRef(null);
  const scorecardGroupRef = useRef(null);
  const progressOverTimeChartRef = useRef(null);
  const detailedTableRef = useRef(null);
  const recommendationsRef = useRef(null);
  const moreMenuButtonRef = useRef(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      dateRangeCalendarRef,
      filterBarRef,
      scorecardGroupRef,
      progressOverTimeChartRef,
      detailedTableRef,
      recommendationsRef,
      moreMenuButtonRef
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};